<template>
    <div class="FoldingSandard">
        <Title firstName="折标煤" lastName="COAL CONVERSION STANDARD" />
        <div class="echarts">
            <div class="tab">
                <div :class="tabIdx == 0?'report se':'report'" @click="tabTitle(0)">总(折煤标)</div>
                <div :class="tabIdx == 1?'report se':'report'" @click="tabTitle(1)">用电</div>
                <div :class="tabIdx == 2?'report se':'report'" @click="tabTitle(2)">用水</div>
            </div>
            
            <div class="charts" v-if="$store.state.nav == 'energy'">
                <charts id="ratio" :series="seriesOption" :xData="xData" unit="kgce"></charts>
            </div>
            <div class="tabdate">
                <div :class="dateIdx == 0?'report se':'report'" @click="tabdate(0)">日</div>
                <div :class="dateIdx == 1?'report se':'report'"  @click="tabdate(1)">月</div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Title = () => import('../../../../components/title/Title')
const SelectList = () => import('../../../../components/title/selectList.vue')
const Bar = () => import('../../../../components/echarts/bar.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const Graph = () => import('../../../../components/echarts/graph.vue')

import { getSevenDays, getMonthTime, getMonthDays, lastMonth, getTodayYesTime  } from '../../../../utils/common/index'
export default {
    data(){
        return {
            chartId:'EnergyAnalysisener',
            xData:[],
            xData1:[],
            xData2:[],
            seriesOption:[],
            tagList:[
                {
                    id:1,
                    name:'日'
                },
                {
                    id:2,
                    name:'月'
                },
            ],
            tabIdx:0,  // 切换种类
            currentArr:[], // 当前的图表数组
            allArr:[[[], []], [[], []], [[], []]] ,// 所有的图表数组天
            allArrMon:[[[], []], [[], []], [[], []]] , // 月
            dateIdx:0,
        }
    },
    components:{
        Title,
        SelectList,
        Bar,
        charts,
        Graph
    },
    computed:{

    },
    created(){
        this.xData1 = []
        for(let i = 0; i <= 24; i++){
            this.xData1.push((i<10?'0'+i:i)+':00')
        }
        // 获取当月所有天数 
        this.xData2 = getMonthDays()
        
        this.getCoal()
        this.getCoalMon()
    },
    methods:{
        tabdate(idx){
            let _this = this
            this.dateIdx = idx
            if(this.dateIdx == 0){
                this.xData = this.xData1
                this.currentArr = this.allArr[this.tabIdx]
                this.seriesOption = [{
                    name:"今日",
                    type:"line",
                    data:_this.currentArr[0]
                },{
                    name:"昨日",
                    type:"line",
                    data:_this.currentArr[1]
                }]
            }else{
                this.xData = this.xData2
                this.currentArr = this.allArrMon[this.tabIdx]
                this.seriesOption = [{
                    name:"本月",
                    type:"line",
                    data:_this.currentArr[0]
                },{
                    name:"上月",
                    type:"line",
                    data:_this.currentArr[1]
                }]
            }
        },
        tabTitle(idx){
            let _this = this
            this.tabIdx = idx
            if(this.dateIdx == 0){
                this.currentArr = this.allArr[this.tabIdx]
                this.seriesOption = [{
                    name:"今日",
                    type:"line",
                    data:_this.currentArr[0]
                },{
                    name:"昨日",
                    type:"line",
                    data:_this.currentArr[1]
                }]
            }else{
                this.currentArr = this.allArrMon[this.tabIdx]
                this.seriesOption = [{
                    name:"本月",
                    type:"line",
                    data:_this.currentArr[0]
                },{
                    name:"上月",
                    type:"line",
                    data:_this.currentArr[1]
                }]
            }
            
        },
        async getCoal(){
            let _this = this
            let time = getTodayYesTime()
            let dian = new Date().getHours()
            // 获取总折标煤
            let data = {
                date:`${time.today}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'DAY'
            }
            let data2 = {
                date:`${time.yesterday}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'DAY'
            }
            let res = await Promise.all([
                _this.$http.getConvertedStandardCoal(data), 
                _this.$http.getConvertedStandardCoal(data2)
            ])
            // if(res.data.code == 200){
                let electricity = res[0].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let water = res[0].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)

                let electricityYes = res[1].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                })
                let waterYes = res[1].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                let all = res[0].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let allYes = res[1].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                this.allArr = [[all, allYes], [electricity, electricityYes], [water, waterYes]]
            // }
                // console.log(res);
            this.tabTitle(0)
        },
        async getCoalMon(){
            let _this = this
            let time = getTodayYesTime()
            let mon = lastMonth()
            let dian = new Date().getDate()
            // 获取总折标煤
            let data = {
                date:`${time.today}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'MONTH'
            }
            let data2 = {
                date:`${mon}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'MONTH'
            }
            let res = await Promise.all([
                _this.$http.getConvertedStandardCoal(data), 
                _this.$http.getConvertedStandardCoal(data2)
            ])
            // if(res.data.code == 200){
                let electricity = res[0].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let water = res[0].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)

                let electricityYes = res[1].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                })
                let waterYes = res[1].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                let all = res[0].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let allYes = res[1].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                this.allArrMon = [[all, allYes], [electricity, electricityYes], [water, waterYes]]
            // }
                // console.log(res);
        }
        
    }
}
</script>

<style lang="less" scoped>
    
    .FoldingSandard{
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 2vw;
        z-index: 1;
        
        
        .echarts{
            overflow: hidden;
            position: relative;
            height: 26vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            padding-top: 1vh;
            .tab{
                height: 15%;
                display: flex;
                color: rgba(230, 243, 253, 0.7);
                justify-content: space-evenly;
                align-items: center;
                align-content: space-evenly;
                flex-wrap: wrap;
                padding: 0 1vw;
                .report{
                    background: url("../../../../assets/img/btn3.png") no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    width: 90rem;
                    cursor: pointer;
                }
                .se{
                    background: url("../../../../assets/img/btn4.png") no-repeat ;
                    background-size: 100% 100%;
                }
            }
            .tabdate{
                height: 15%;
                display: flex;
                color: rgba(230, 243, 253, 0.7);
                justify-content: space-evenly;
                align-items: center;
                align-content: space-evenly;
                flex-wrap: wrap;
                padding: 0 1vw;
                .report{
                    background: url("../../../../assets/img/btn1.png") no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    height: 34rem;
                    line-height: 34rem;
                    font-size: 14rem;
                    padding:0 1vw ;
                    cursor: pointer;
                }
                .se{
                    background: url("../../../../assets/img/btn2.png") no-repeat ;
                    background-size: 100% 100%;
                }
            }
            .charts{
                height: 70%;
                padding: 2vh 0 1vh;
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>